module.exports = __webpack_public_path__ + "assets/img/Type E (37).b542db12.jpg";